export default __webpack_public_path__ + "static/media/Hero4.c98d0b3e.png";